export default __webpack_public_path__ + "static/CentraNo2-Light-4738942b1092eef06ce89dbca1ad5f71.woff";